import(/* webpackMode: "eager" */ "/home/runner/work/personal-website/personal-website/app/(tools)/tools/uuid-generator/page.tsx");
